import { useState } from 'react';
import { Button } from '@shared/ui/Button';
import { Small } from '../styles';

/** Долей систем в ячейке без раскрытия. */
const SHARES_SHOWN = 4;

/** Доли систем строки ведомости: «ОВ2 · В1 — 5»; длинный список — под «ещё». */
export function SystemShares({ lines }: { lines: string[] }) {
  const [all, setAll] = useState(false);
  if (lines.length === 0) return <Small>—</Small>;
  const shown = all ? lines : lines.slice(0, SHARES_SHOWN);
  return (
    <>
      {shown.map((l) => (
        <Small key={l}>{l}</Small>
      ))}
      {lines.length > SHARES_SHOWN && (
        <Button type="button" $variant="ghost" $size="sm" onClick={() => setAll((v) => !v)}>
          {all ? 'Свернуть' : `и ещё ${lines.length - SHARES_SHOWN}`}
        </Button>
      )}
    </>
  );
}
